<script lang="ts">

import { Bar, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins;

export default {
  name: 'ViewChartJsConectados',
  extends: Bar,
  mixins: [reactiveProp],
  props: ['title', 'conectados'],
  data() {
  },
}
</script>